import React from "react"
import {QuickSearchResultProps} from "./@type";
import SettingsModule from "../../../../../../core/modules/settings-module";


export default function QuickSearch_ResultModule(props:QuickSearchResultProps) {

    const setting = props.searchResult.item as SettingsModule

    const iconClass = Classes('icon-22 m-r-10', setting.svgIcon, !setting.canAccess ? "disabled" : "")
    const icon= <div className={iconClass}/>

    const classes = Classes("row ui5-list-item", props.className, {
        'selected': props.searchResult.index === props.quickSearch.keyboardIterator.currentIndex
    })

    return (
        <div className={classes} onClick={props.searchResult.onClick}>
            <div className="cell">
                <div className="title">
                    {icon}
                    <div className="ui5-txt-default max-w-250">{setting.name || setting.name}</div>
                    {!setting.canAccess && <div className="ui5-txt-not-important m-l-10"> (No access) </div>}
                </div>
            </div>
            <div className="cell align-r"/>
        </div>
    )
}
